import React, {useEffect, useState} from "react";
import QuadralModal from "@quadral/quadral-component-common/dist/components/modal"
import { onlineProcessesService } from "../../services";
import { QuadralLoaderProvider } from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography'
import QuadralContainer from '@quadral/quadral-component-common/dist/components/container'
import QuadralButton from "@quadral/quadral-component-common/dist/components/button"

export default function ParticipationValidationModal ({open, setOpen, statuses, getDocStatusCount, getDocStatusIcon, getDocStatus, participation, setParticipationVerified, updateParticipation, showLoader, hideLoader, ...props}) {

    const [decision, setDecision] = useState('valide');
    const [params, setParams] = useState('');

    function validateParticipation(status){
        showLoader();
        const participationId = participation?.id;
        const body = status;
        onlineProcessesService.updateParticipation({ participationId }, body)
            .then(response => {
                hideLoader();
                setParticipationVerified(true);
                updateParticipation();
                props.quadralToast.success('Participation vérifiée avec succès.');
                setOpen(false);
            })
            .catch(error => {
                hideLoader();
                props.quadralToast.error(error.response?.data?.message || 'Erreur lors de la vérification de la participation.');
                setOpen(false);
            });
    }

    useEffect(()=>{
        if(decision === "valide"){
            setParams("reponse_validee")
        } else if (decision === "complement"){
            setParams("complements_attendu")
        } else {
            setParams("annulee")
        }
    },[decision])
    
    return (
        <QuadralModal
            open={open}
            setOpen={setOpen}
            title='Finaliser la participation enquête'
            noButton
            action={<>
                <QuadralButton color='secondary' onClick={() => setOpen(false)}>
                    Annuler
                </QuadralButton>
                <QuadralButton color='primary' onClick={()=> validateParticipation(params) }>
                    Confirmer
                </QuadralButton>
            </>}
        >
            <QuadralLoaderProvider>
                <QuadralTypography variant='h4'>Résumé du traitement des pièces justificatives</QuadralTypography>
                {statuses && (<>
                    <QuadralContainer orientation='column'>
                        <QuadralTypography color='error'> 
                            {getDocStatusIcon("refuse")} {getDocStatus("refuse")} : {getDocStatusCount("refuse")} 
                        </QuadralTypography>
                        <QuadralTypography color='success'> 
                            {getDocStatusIcon("valide")} {getDocStatus("valide")} : {getDocStatusCount("valide")} 
                        </QuadralTypography>
                        
                    </QuadralContainer>
                </>)}
                <QuadralTypography variant='h4'>Décision sur la participation</QuadralTypography>
                <div>
                    <label>
                        <input
                            type="radio"
                            name="decision"
                            value="valide"
                            checked={decision === 'valide'}
                            onChange={(e) => setDecision(e.target.value)}
                        />
                        <span className="ml-2">Participation validée</span>
                    </label>
                </div>
                <div>
                    <label>
                        <input
                            type="radio"
                            name="decision"
                            value="complement"
                            checked={decision === 'complement'}
                            onChange={(e) => setDecision(e.target.value)}
                        />
                        <span className="ml-2">Demander des compléments</span>
                    </label>
                </div>
                <div>
                    <label>
                        <input
                            type="radio"
                            name="decision"
                            value="annulee"
                            checked={decision === 'annulee'}
                            onChange={(e) => setDecision(e.target.value)}
                        />
                        <span className="ml-2">Participation annulée</span>
                    </label>
                </div>
            </QuadralLoaderProvider>
        </QuadralModal>
    );
}